import { Link, Stack } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { PageTitle } from '@/components/PageTitle';
import { AuthenticationSection } from '@/components/sofarApi/AuthenticationSection';
import { DeliverySection } from '@/components/sofarApi/DeliverySection';
import { ConnectedAccountsSection } from '@/components/userAccount/ConnectedAccountsSection';

export const SofarApi = () => {
    return (
        <Container maxWidth="lg">
            <PageTitle title="Sofar API" />
            <Stack spacing={3}>
                <Typography variant="h4" gutterBottom>
                    Making use of the Sofar API
                </Typography>
                <Typography variant="body1" gutterBottom>
                    For detailed documentation on available API endpoints and how to format requests, check out the
                    <Link href="https://docs.sofarocean.com/spotter-and-smart-mooring" sx={{ mx: 0.5 }}>
                        Sofar API documentation
                    </Link>
                    website.
                </Typography>
                <AuthenticationSection />
                <DeliverySection />
                <ConnectedAccountsSection />
            </Stack>
        </Container>
    );
};
